import { render, staticRenderFns } from "./teachingActivityDetial.vue?vue&type=template&id=d2724db2&scoped=true"
import script from "./teachingActivityDetial.vue?vue&type=script&lang=js"
export * from "./teachingActivityDetial.vue?vue&type=script&lang=js"
import style0 from "./teachingActivityDetial.vue?vue&type=style&index=0&id=d2724db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2724db2",
  null
  
)

export default component.exports